import { useFiltrosGlobales } from '@/lib/FiltrosGlobalesContext';
import { cliente } from '@/lib/cliente';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export function useAreaCosteoResumen() {
  const { filtros } = useFiltrosGlobales();
  return useQuery({
    queryKey: ['area-costeo-resumen', filtros],
    queryFn: () => cliente.areaCosteo.resumen(filtros),
    // Mantener los datos anteriores mientras se refetchea al cambiar filtros,
    // así isLoading no se dispara, la pantalla no se desmonta y NO se pierde la
    // configuración de la pivot (filas/columnas/métricas).
    placeholderData: keepPreviousData,
  });
}

export function useCostoPorCategoria() {
  const { filtros } = useFiltrosGlobales();
  return useQuery({
    queryKey: ['costo-por-categoria', filtros],
    queryFn: () => cliente.areaCosteo.porCategoria(filtros),
  });
}

export function usePresupuestoPartidas() {
  const { filtros } = useFiltrosGlobales();
  return useQuery({
    queryKey: ['presupuesto-partidas', filtros],
    queryFn: () => cliente.presupuesto.porPartida(filtros),
  });
}

/** Fechas disponibles para el selector de periodos. No depende de filtros. */
export function usePeriodosDisponibles() {
  return useQuery({
    queryKey: ['periodos-disponibles'],
    queryFn: () => cliente.periodos.disponibles(),
    staleTime: 1000 * 60 * 30, // el calendario de datos cambia poco
  });
}

/** Estados de venta disponibles para el filtro global. No depende de filtros. */
export function useEstadosVenta() {
  return useQuery({
    queryKey: ['estados-venta'],
    queryFn: () => cliente.estados.venta(),
    staleTime: 1000 * 60 * 30,
  });
}
